var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"0"}},[_c('v-navigation-drawer',{staticClass:"sidebar",staticStyle:{"z-index":"3"},attrs:{"fixed":"","hide-overlay":"","permanent":true,"width":"300"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }